var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pt-4", attrs: { fluid: "" } },
    [
      _vm.value
        ? _c(
            "div",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { sm: "3", cols: "12" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.sourceSchema.source.enum,
                          label: _vm.sourceSchema.source.title,
                          hint: _vm.sourceSchema.source.tooltip,
                          "persistent-hint": "",
                          dense: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value: _vm.computedValue.source,
                          callback: function ($$v) {
                            _vm.$set(_vm.computedValue, "source", $$v)
                          },
                          expression: "computedValue.source",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.value.source === "Market"
                    ? _c(
                        "v-col",
                        { attrs: { sm: "3", cols: "12" } },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "Market Name",
                              items: _vm.availableMarkets,
                              dense: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: _vm.computedValue.market_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.computedValue, "market_name", $$v)
                              },
                              expression: "computedValue.market_name",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.submarketType === "reserve" &&
                  _vm.value.source === "Market"
                    ? _c(
                        "v-col",
                        { attrs: { sm: "3", cols: "12" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.sourceSchema.index_type.enum,
                              label: _vm.sourceSchema.index_type.title,
                              hint: _vm.sourceSchema.index_type.tooltip,
                              "persistent-hint": "",
                              dense: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "selection",
                                  fn: function (data) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("replaceDash")(data.item)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item",
                                  fn: function (data) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("replaceDash")(data.item)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1811715964
                            ),
                            model: {
                              value: _vm.computedValue.index_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.computedValue, "index_type", $$v)
                              },
                              expression: "computedValue.index_type",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  !["Custom", "IHR"].includes(_vm.value.source) &&
                  _vm.submarketType !== "reserve"
                    ? _c(
                        "v-col",
                        { attrs: { sm: "6", cols: "12" } },
                        [
                          _vm.showNodeData
                            ? _c("InputMarketNode", {
                                key: "node-dd-" + _vm.nodeDropdownKey,
                                attrs: {
                                  market: _vm.value.market_name,
                                  "index-type": _vm.value.index_type,
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: _vm.computedMarketNode,
                                  callback: function ($$v) {
                                    _vm.computedMarketNode = $$v
                                  },
                                  expression: "computedMarketNode",
                                },
                              })
                            : _c("v-text-field", {
                                attrs: {
                                  label: _vm.sourceSchema.node_id.title,
                                  hint: _vm.sourceSchema.node_id.tooltip,
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: _vm.computedValue.node_id,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedValue,
                                      "node_id",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "computedValue.node_id",
                                },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.value.source === "IHR"
                    ? [
                        _c(
                          "v-col",
                          { attrs: { sm: "5", cols: "12" } },
                          [
                            _c("FeathersAutocomplete", {
                              attrs: {
                                label: "Forecast ID",
                                "service-name": "forecasts",
                                "item-text": "id",
                                params: _vm.forecastsParams,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(_vm._s(data.item.id)),
                                            ]),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatForecastSubtitle(
                                                    data.item
                                                  )
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2797639141
                              ),
                              model: {
                                value: _vm.computedValue.node_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.computedValue, "node_id", $$v)
                                },
                                expression: "computedValue.node_id",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { sm: "4", cols: "12" } },
                          [
                            _c("v-select", {
                              attrs: {
                                label: "Forecast Type",
                                items: _vm.forecastTypeItems,
                              },
                              model: {
                                value: _vm.computedValue.ihr_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.computedValue, "ihr_type", $$v)
                                },
                                expression: "computedValue.ihr_type",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.submarketType === "reserve"
                          ? _c(
                              "v-col",
                              { attrs: { sm: "4", cols: "12" } },
                              [
                                _c("v-select", {
                                  attrs: {
                                    label: "Ancillary Type",
                                    items: _vm.ihrReserveLabelItems,
                                  },
                                  model: {
                                    value: _vm.computedValue.ihr_reserve_label,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedValue,
                                        "ihr_reserve_label",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "computedValue.ihr_reserve_label",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm.value.source === "Custom"
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { sm: "4", cols: "12" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.sourceSchema.price_unit.enum,
                              label: _vm.sourceSchema.price_unit.title,
                              hint: _vm.sourceSchema.price_unit.tooltip,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: _vm.computedValue.price_unit,
                              callback: function ($$v) {
                                _vm.$set(_vm.computedValue, "price_unit", $$v)
                              },
                              expression: "computedValue.price_unit",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { sm: "4", cols: "12" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.sourceSchema.energy_unit.enum,
                              label: _vm.sourceSchema.energy_unit.title,
                              hint: _vm.sourceSchema.energy_unit.tooltip,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: _vm.computedValue.energy_unit,
                              callback: function ($$v) {
                                _vm.$set(_vm.computedValue, "energy_unit", $$v)
                              },
                              expression: "computedValue.energy_unit",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { sm: "4", cols: "12" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.sourceSchema.power_unit.enum,
                              label: _vm.sourceSchema.power_unit.title,
                              hint: _vm.sourceSchema.power_unit.tooltip,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: _vm.computedValue.power_unit,
                              callback: function ($$v) {
                                _vm.$set(_vm.computedValue, "power_unit", $$v)
                              },
                              expression: "computedValue.power_unit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.value.source === "Custom"
                ? _c("InputYearlyProfile", {
                    attrs: {
                      "profile-type": _vm.sourceSchema.profile.profile_type,
                      label: _vm.sourceSchema.profile.title,
                      hint: _vm.sourceSchema.profile.tooltip,
                      num_years: _vm.num_years,
                      "multi-year-upload": true,
                      "object-value": "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedValue.profile,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedValue, "profile", $$v)
                      },
                      expression: "computedValue.profile",
                    },
                  })
                : _vm._e(),
              _vm.source === "Custom"
                ? _c("InputYearlyProfile", {
                    attrs: {
                      "profile-type":
                        _vm.sourceSchema.performance_price.profile_type,
                      label: _vm.sourceSchema.performance_price.title,
                      hint: _vm.sourceSchema.performance_price.tooltip,
                      num_years: _vm.num_years,
                      "multi-year-upload": true,
                      nullable: "",
                      "object-value": "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.performancePrice,
                      callback: function ($$v) {
                        _vm.performancePrice = $$v
                      },
                      expression: "performancePrice",
                    },
                  })
                : _vm._e(),
              _vm.value.source === "Market" && _vm.submarketType !== "reserve"
                ? _c("v-select", {
                    attrs: {
                      items: _vm.sourceSchema.index_type.enum,
                      label: _vm.sourceSchema.index_type.title,
                      hint: _vm.sourceSchema.index_type.tooltip,
                      "persistent-hint": "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "selection",
                          fn: function (data) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("replaceDash")(data.item)) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "item",
                          fn: function (data) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("replaceDash")(data.item)) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1811715964
                    ),
                    model: {
                      value: _vm.computedValue.index_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedValue, "index_type", $$v)
                      },
                      expression: "computedValue.index_type",
                    },
                  })
                : _vm._e(),
              _vm.submarketType === "reserve" && _vm.source === "Market"
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Ancillary Price Type",
                              items: _vm.ancillaryPriceTypeItems,
                              dense: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: _vm.computedValue.ancillary_price_type,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedValue,
                                  "ancillary_price_type",
                                  $$v
                                )
                              },
                              expression: "computedValue.ancillary_price_type",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Zone/Region ID",
                              items: _vm.ancillaryPriceIds,
                              dense: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: _vm.computedValue.node_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.computedValue, "node_id", $$v)
                              },
                              expression: "computedValue.node_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.value.source === "PC"
                ? _c("v-text-field", {
                    attrs: {
                      label: _vm.sourceSchema.index_type.title,
                      hint: _vm.sourceSchema.index_type.tooltip,
                      type: "Number",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: _vm.computedValue.index_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedValue, "index_type", _vm._n($$v))
                      },
                      expression: "computedValue.index_type",
                    },
                  })
                : _vm._e(),
              _vm.showNodeData
                ? _c(
                    "v-card",
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _vm.showNodeMap
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "ml-4",
                                      attrs: { cols: "12", md: "5" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { style: "height: 200px" },
                                        [
                                          _c(
                                            "LMap",
                                            {
                                              key: "nodeMap-" + _vm.nodeMapKey,
                                              ref: "map",
                                              staticStyle: {
                                                height: "100%",
                                                width: "100%",
                                                "z-index": "0",
                                              },
                                              attrs: {
                                                zoom: 5,
                                                center: _vm.projectCoordinates,
                                                bounds: _vm.mapBounds,
                                                options: {
                                                  attributionControl: false,
                                                },
                                              },
                                            },
                                            [
                                              _c("LTileLayer", {
                                                attrs: { url: _vm.mapUrl },
                                              }),
                                              _vm.projectCoordinates
                                                ? _c("LMarker", {
                                                    attrs: {
                                                      "lat-lng":
                                                        _vm.projectCoordinates,
                                                      icon: _vm.projectIcon,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm.nodeCoordinates
                                                ? _c(
                                                    "LMarker",
                                                    {
                                                      attrs: {
                                                        "lat-lng":
                                                          _vm.nodeCoordinates,
                                                        icon: _vm.nodeIcon,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "LPopup",
                                                        {
                                                          attrs: {
                                                            options: {
                                                              offset: [0, -24],
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.marketNode
                                                                    .Name +
                                                                    " - " +
                                                                    _vm
                                                                      .marketNode
                                                                      .PTID
                                                                ) +
                                                                " "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.nodeCoordinates
                                                ? _c("LPolyline", {
                                                    attrs: {
                                                      "lat-lngs":
                                                        _vm.polylineLatLngs,
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("p", [
                                        _vm._v(
                                          "Distance from project: " +
                                            _vm._s(_vm.nodeProjectDistance) +
                                            " km"
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.showNodeMap
                                ? _c("v-divider", {
                                    staticClass: "mx-2",
                                    attrs: { vertical: "" },
                                  })
                                : _vm._e(),
                              !_vm.disablePriceData
                                ? _c(
                                    "v-col",
                                    {
                                      key: "priceChart-" + _vm.nodeMapKey,
                                      staticClass: "text-center",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _vm.showChartBtn
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                outlined: "",
                                                color: "primary",
                                                loading:
                                                  _vm.isFindPriceServicePending,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.loadPriceChart =
                                                    !_vm.loadPriceChart
                                                },
                                              },
                                            },
                                            [_vm._v("Display Prices")]
                                          )
                                        : _c("Plotly", {
                                            attrs: {
                                              layout: _vm.priceChartLayout,
                                              data: _vm.priceChartData,
                                            },
                                          }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: { cols: "12" },
                                    },
                                    [_c("p", [_vm._v("No price data")])]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.submarketType === "reserve" && _vm.source === "Market"
                ? _c(
                    "v-card",
                    [
                      _c("v-card-text", [
                        _c("p", [
                          _c("span", { staticClass: "font-weight-medium" }, [
                            _vm._v("Available Years: "),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.ancillaryAvailableYears)),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-divider", { staticClass: "my-4" }),
              _c("InputYearlyProfile", {
                attrs: {
                  "profile-type": "AVAILABILITY",
                  label: _vm.sourceSchema.availability.title,
                  hint: _vm.sourceSchema.availability.tooltip,
                  num_years: _vm.num_years,
                  "multi-year-upload": true,
                  nullable: "",
                  "object-value": "",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: _vm.computedValue.availability,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedValue, "availability", $$v)
                  },
                  expression: "computedValue.availability",
                },
              }),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { sm: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.sourceSchema.market_friction.title,
                          suffix: _vm.sourceSchema.market_friction.unit,
                          hint: _vm.sourceSchema.market_friction.tooltip,
                          type: "Number",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value: _vm.computedValue.market_friction,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedValue,
                              "market_friction",
                              _vm._n($$v)
                            )
                          },
                          expression: "computedValue.market_friction",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { sm: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          suffix: _vm.sourceSchema.bid_adder.unit,
                          label: _vm.sourceSchema.bid_adder.title,
                          hint: _vm.sourceSchema.bid_adder.tooltip,
                          type: "Number",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value: _vm.computedValue.bid_adder,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedValue,
                              "bid_adder",
                              _vm._n($$v)
                            )
                          },
                          expression: "computedValue.bid_adder",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { sm: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.sourceSchema.transport_tariff.title,
                          suffix: _vm.sourceSchema.transport_tariff.unit,
                          hint: _vm.sourceSchema.transport_tariff.tooltip,
                          type: "Number",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value: _vm.computedValue.transport_tariff,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.computedValue,
                              "transport_tariff",
                              _vm._n($$v)
                            )
                          },
                          expression: "computedValue.transport_tariff",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("InputYearly", {
                attrs: {
                  label: _vm.sourceSchema.vom_purchases.title,
                  hint: _vm.sourceSchema.vom_purchases.tooltip,
                  suffix: _vm.sourceSchema.vom_purchases.unit,
                  num_years: _vm.num_years,
                  year_start: _vm.year_start,
                  fill: "",
                  "fill-value": _vm.sourceSchema.vom_purchases.items.default,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: _vm.computedValue.vom_purchases,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedValue, "vom_purchases", $$v)
                  },
                  expression: "computedValue.vom_purchases",
                },
              }),
              _c("InputYearly", {
                attrs: {
                  label: _vm.sourceSchema.vom_sales.title,
                  suffix: _vm.sourceSchema.vom_sales.unit,
                  hint: _vm.sourceSchema.vom_sales.tooltip,
                  num_years: _vm.num_years,
                  year_start: _vm.year_start,
                  fill: "",
                  "fill-value": _vm.sourceSchema.vom_sales.items.default,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: _vm.computedValue.vom_sales,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedValue, "vom_sales", $$v)
                  },
                  expression: "computedValue.vom_sales",
                },
              }),
              _c("InputYearly", {
                attrs: {
                  label: _vm.sourceSchema.transaction_adder.title,
                  suffix: _vm.sourceSchema.transaction_adder.unit,
                  hint: _vm.sourceSchema.transaction_adder.tooltip,
                  num_years: _vm.num_years,
                  year_start: _vm.year_start,
                  fill: "",
                  "fill-value":
                    _vm.sourceSchema.transaction_adder.items.default,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: _vm.computedValue.transaction_adder,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedValue, "transaction_adder", $$v)
                  },
                  expression: "computedValue.transaction_adder",
                },
              }),
              _c("v-switch", {
                attrs: {
                  label: _vm.sourceSchema.buy_limits.title,
                  hint: "Limit energy import over the period or each interval",
                  "persistent-hint": "",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: _vm.computedValue.buy_limits,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedValue, "buy_limits", $$v)
                  },
                  expression: "computedValue.buy_limits",
                },
              }),
              _c("v-switch", {
                attrs: {
                  label: _vm.sourceSchema.sell_limits.title,
                  hint: "Limit energy export over the period or each interval",
                  "persistent-hint": "",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: _vm.computedValue.sell_limits,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedValue, "sell_limits", $$v)
                  },
                  expression: "computedValue.sell_limits",
                },
              }),
              _vm._l(_vm.limitsForRender, function (limit) {
                return _c("InputYearly", {
                  key: limit[0],
                  attrs: {
                    suffix: limit[1].unit,
                    label: limit[1].title,
                    hint: limit[1].tooltip,
                    num_years: _vm.num_years,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$emit("change")
                    },
                  },
                  model: {
                    value: _vm.computedValue[limit[0]],
                    callback: function ($$v) {
                      _vm.$set(_vm.computedValue, limit[0], $$v)
                    },
                    expression: "computedValue[limit[0]]",
                  },
                })
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          attrs: {
            app: "",
            right: "",
            color: _vm.snackbarInfo.color,
            timeout: "8000",
          },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v(" " + _vm._s(_vm.snackbarInfo.message) + " "),
          _c(
            "v-btn",
            {
              attrs: { color: "white", dark: "", icon: "", small: "" },
              on: {
                click: function ($event) {
                  _vm.snackbar = false
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }